module.exports = __webpack_public_path__ + "../static/img/databank-mysql-icon.4d58c993.png";